// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__ySK4o","title":"BackImages_title__2Zghq","images":"BackImages_images__WWSsG"};